module.exports = __webpack_public_path__ + "static/media/pexels-3.1574dd72.jpg";